import React from 'react';

export default ({isSuper, children, userData}) => {
	return isSuper ? React.cloneElement(children, {isSuper, userData}) : (
		<div className='Super'>
			<h1>Not Authorized</h1>
			<p>Additional account permissions needed to view this page.</p>
		</div>
	)
}